import React, { HtmlHTMLAttributes } from "react";
import AppTheme from "../../theme/AppTheme";

const AppName: React.FC<HtmlHTMLAttributes<HTMLDivElement>> = (props) => {
  return (
    <div
      style={{ color: AppTheme.colors.primary }}
      className={`${props.className ?? ""}`}
    >
      <span className="uppercase">
        <span className="font-light">Origin</span>
        <span className="font-bold">records</span>
      </span>
    </div>
  );
};

export default AppName;
